import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { fetchFiles } from "../../../api/files";
import SkirtTable from "../../../components/skirt-table/SkirtTable";
import { toast } from "../../../helpers/smu-alerts/smu-lerts";
import { StoreContext } from "../../../store/StoreContext";

const Skirt = () => {
  const { category } = useParams();
  const { skirts } = useContext(StoreContext);

  const [skirt, setSkirt] = useState(null);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!category || !skirts.length) return;

    const _skirt = skirts.find((s) => s.id === Number(category));
    setSkirt(_skirt);

    fetchFiles(category)
      .then(({ data, error }) => {
        if (!!error) throw new Error(error?.message);
        setFiles(data?.data?.documents);
        setLoading(false)
      })
      .catch((err) => {
        console.error(err);//toast({ icon: "error", title: err });
      });

  }, [category, skirts]);

  return (
    <Row>
      <Col col={12} className="mb-4">
        <SkirtTable title={skirt?.title} files={files} setFiles={setFiles} loading={loading}/>
      </Col>
    </Row>
  );
};

export default Skirt;
